import {  types } from '../../actions'
import { arrayToObject } from '../../../utils/functions/arraytoobject'
  
function getSeasonDates(seasons){
  const seasonDates = []

  seasons.map(function(season) {
    const s = {
      id: season.id,
      description: season.description,
      isCurrent:season.isCurrent,
      isSeasonSet:season.isSeasonSet,
      year: season.year,
      startDate: season.startDate,
      endDate: season.endDate,
      membershipStartDate: season.membershipStartDate,
      membershipEndDate: season.membershipEndDate,
      membershipVerificationStartDate: season.membershipVerificationStartDate,
      juniorTeamUSAEligibilityDate:season.juniorTeamUSAEligibilityDate,
      athleteBioOpens:season.athleteBioOpens,
      athleteBioCloses:season.athleteBioCloses
    }
    seasonDates.push(s)
  })
  return seasonDates
}
    
   export default function seasondates(state={},action) {
        const {  payload } = action
        
        switch(action.type) {
          case (types.Season.FETCH_ACTIVE_SEASONS): {
            
            const { data } = payload
         
            if(data) {
            
                const defaultId = data[0].id.toString()
                const seasonDates = getSeasonDates(data)
                const dates = arrayToObject(seasonDates,'id')
                const response = {
                  seasondates:dates,
                  settingsseason:defaultId,
                  initialstate:dates,
                  datesreset:false,
                  savingdates:false
                }
            
                return  { 
									...state, 
                  values:
                  {
                    ...state.values ,
                    ...response        
                  },
                  fields: 
                  {
                    ...state.fields,
                    ...response 
                  }
                }
            }
            else {
                return state
            }
          }
          case (types.Season.SAVING_DATA): {
            const response = {
              savingdates: true,
            }
            return  { ...state, 
              values: {
                ...state.values ,
                ...response        
              },
              fields: {
                ...state.fields,
                ...response 
              }
            }
          }
          case (types.Season.SAVE_SEASON_DATES): {
           
           const datasaved  = true 
           const savingdates = false
           const isSettingSeason = false

           const response = {
            savingdates,
            datasaved,
            isSettingSeason,
            initialstate:state.values.seasondates,
            datesreset:false 
           }

           return  { ...state, 
              values: {
                        ...state.values ,
                        ...response        
                      },
              fields: {
                        ...state.fields,
                        ...response 
                      }
            }
          
          }
          case (types.Season.TRIGGER_SEASON): {
            const { data } = payload
         
            if(data) {
            
                const defaultId = data[data.length - 1].id.toString()
                const seasonDates = getSeasonDates(data)
                const dates = arrayToObject(seasonDates,'id')

                const response = {
                  seasondates:dates,
                  settingsseason:defaultId,
                  initialstate:dates,
                  datesreset:false,
                  savingdates:false
                }
            
                return  { 
									...state, 
                  values:
                  {
                    ...state.values ,
                    ...response        
                  },
                  fields: 
                  {
                    ...state.fields,
                    ...response 
                  }
                }
            }
            else {
                return state
            }
          }
          case types.RESET_DATES_SETTINGS:{
             
            const { initialstate } = state.values

            const response = {
              seasondates:initialstate,
              datesreset:true
            }
          
            return  { ...state, 
                values: {
                         ...state.values,
                         ...response
                       },
                fields: {
                         ...state.fields,
                         ...response
                       }
             }
        }
          default: return state
        }
      } 


// WEBPACK FOOTER //
// ./src/redux/reducers/forms/seasondates.js